import config from '../../../../config';
import Request from '../../../Request';

export default function update(reservationId, id, values, onSuccess, onFailure) {
  return Request.patch(`${config.apiUrl}/reservations/${reservationId}/reservation_items/${id}`, {
    reservation_item: values
  }, onSuccess, onFailure);
}